import React from "react";
import classNames from "classnames";

type InputProps = {
    type?: string;
    name?: string;
    placeholder?: string;
    value?: string;
    onChange?: React.ChangeEventHandler<HTMLInputElement>;
    className?: string;
};

const Input = ({
    type = "text",
    name,
    placeholder,
    value,
    onChange,
    className,
}: InputProps) => {
    return (
        <input
            type={type}
            name={name}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            className={classNames(
                "w-full bg-white text-gray-800 placeholder-gray-400 rounded-xl px-4 py-3 font-sans text-base shadow-sm focus:outline-none focus:ring-2 focus:ring-primary",
                className
            )}
        />
    );
};

export default Input;

